var exports = {
  "k": "x31de4314--7d2b06--container",
};

module.exports = exports;
